import { render } from "./InvestorCenter.vue?vue&type=template&id=51b8cdfa&scoped=true"
import script from "./InvestorCenter.vue?vue&type=script&lang=js"
export * from "./InvestorCenter.vue?vue&type=script&lang=js"

import "./InvestorCenter.vue?vue&type=style&index=0&id=51b8cdfa&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b8cdfa"]])

export default __exports__